// extracted by mini-css-extract-plugin
export default {"image":"Image_image__n0XqG","hidden":"Image_hidden__5r+rG","loading":"Image_loading__Cz5YI"};